/* istanbul ignore file */
import {
  grid,
  maxWidthContainer,
  minBreakpoints,
  primaryRegularFont,
  primarySemiBoldFont,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const wrapper = css`
  margin: 0 0 ${spacing.xl}px 0;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: 0 0 ${spacing.xxxxl}px 0;
    `,
  )}
`;

export const container = css`
  ${grid}
  ${maxWidthContainer}
  grid-row-gap: 0;
`;

export const narrowContainer = css`
  ${mediaQuery(
    { max: minBreakpoints.M },
    css`
      margin: 0 ${spacing.lg}px;
    `,
  )}
`;

export const content = css`
  text-align: center;
  grid-column: span 12;
  margin-top: -${spacing.md}px;
  margin-bottom: ${spacing.xl}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-top: 0;
      margin-bottom: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      order: 1;
      grid-column: span 6;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      grid-column: 2 / span 4;
      align-items: flex-start;
    `,
  )};
`;

export const indentedContent = css`
  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      grid-column: 3 / span 4;
    `,
  )};
`;

export const darkTextContent = css`
  * {
    color: var(--neutral-black-base);
  }
`;

export const imageWrapper = css`
  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      order: 2;
      grid-column: span 6;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      grid-column: 7 / span 5;
    `,
  )};
`;

export const heading = css`
  margin: ${spacing.xl}px 0 0;
  ${primarySemiBoldFont};
  ${theme.responsiveText.HEADING.LG};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: 0;
    `,
  )}
`;

export const subHeading = css`
  margin: ${spacing.md}px 0 0;
  ${primaryRegularFont};
  ${theme.responsiveText.BODY.MD};

  * {
    margin: 0;
    font-size: inherit;
    line-height: inherit;
  }
`;

export const copy = css`
  margin: ${spacing.xl}px 0 0;

  & > * {
    margin: 0 0.5rem;
  }
`;

export const contentReverse = css`
  & div:nth-child(1) {
    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        order: 1;
      `,
    )};

    ${mediaQuery(
      { min: minBreakpoints.XL },
      css`
        grid-column: 2 / span 5;
      `,
    )};
  }
  & div:nth-child(2) {
    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        order: 2;
      `,
    )}

    ${mediaQuery(
      { min: minBreakpoints.XL },
      css`
        grid-column: 8 / span 4;
      `,
    )};
  }
`;

export const iconsBulletList = css`
  list-style-type: none;
  padding: 0;
  margin: ${spacing.xxl}px 0 0 0;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin-top: ${spacing.xxxxl}px;
    `,
  )};
`;

export const iconsBulletItem = css`
  display: flex;
  justify-content: left;
  align-items: center;
  text-align: left;
  gap: ${pxToRem(spacing.xs)};
`;

export const iconsBulletItemImg = css`
  width: 42px;
  height: 32px;
  flex: 0 0 42px;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      width: 63px;
      height: 48px;
      flex: 0 0 63px;
    `,
  )};
`;

export const iconsBulletItemText = css`
  margin: ${spacing.sm}px 0;
  ${theme.responsiveText.BODY.MD};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      max-width: 294px;
      margin: ${spacing.md}px 0;
    `,
  )};
`;

export const qrCode = css`
  display: none;
  max-width: 240px;
  margin: 0 auto;
  padding-top: ${spacing.xxxl}px;
  text-align: center;

  img {
    width: 176px;
    margin: 0 auto;
    border-radius: ${pxToRem(10)};
  }

  p {
    ${primarySemiBoldFont};
    ${theme.responsiveText.HEADING.SM};
  }

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      display: block;
    `,
  )};
`;
